var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheetMapPinGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.61 24.4201C133.61 40.3001 114.37 58.5801 113.55 59.2201C113.138 59.5809 112.608 59.7768 112.06 59.7701C111.51 59.7765 110.976 59.5808 110.56 59.2201C109.75 58.5801 90.5601 40.3001 90.5601 24.4201C90.5601 18.7047 92.8305 13.2234 96.8719 9.18197C100.913 5.14056 106.395 2.87012 112.11 2.87012C117.825 2.87012 123.307 5.14056 127.348 9.18197C131.39 13.2234 133.66 18.7047 133.66 24.4201H133.61Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.7 19.4101C107.127 19.3915 107.553 19.4622 107.951 19.6177C108.349 19.7732 108.71 20.0101 109.011 20.3132C109.313 20.6163 109.547 20.9789 109.7 21.3779C109.853 21.7768 109.921 22.2034 109.9 22.6301C109.92 23.0574 109.85 23.4841 109.696 23.8831C109.542 24.2821 109.306 24.6446 109.005 24.9475C108.703 25.2505 108.341 25.4872 107.942 25.6426C107.544 25.798 107.117 25.8687 106.69 25.8501H104.17V29.4301H102.92V19.4301L106.7 19.4101ZM104.17 24.7401H106.37C106.662 24.7776 106.959 24.7499 107.24 24.6592C107.52 24.5684 107.777 24.4168 107.992 24.2152C108.207 24.0136 108.375 23.767 108.483 23.4929C108.592 23.2189 108.639 22.9243 108.62 22.6301C108.639 22.336 108.592 22.0414 108.483 21.7674C108.375 21.4933 108.207 21.2467 107.992 21.0451C107.777 20.8435 107.52 20.6919 107.24 20.6011C106.959 20.5104 106.662 20.4827 106.37 20.5201H104.17V24.7401Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117 29.5901C114.21 29.5901 112.42 27.5901 112.42 24.3701C112.42 21.1501 114.2 19.2501 117 19.2501C117.978 19.1875 118.944 19.4859 119.717 20.0886C120.489 20.6913 121.013 21.5565 121.19 22.5201H119.87C119.706 21.8919 119.332 21.3389 118.809 20.9531C118.287 20.5674 117.649 20.3722 117 20.4001C114.94 20.4001 113.7 21.8801 113.7 24.4001C113.7 26.9201 114.96 28.4801 117 28.4801C117.387 28.511 117.777 28.4602 118.143 28.3312C118.51 28.2022 118.845 27.9978 119.128 27.7311C119.411 27.4644 119.634 27.1415 119.785 26.783C119.935 26.4246 120.008 26.0387 120 25.6501V25.4701H117.18V24.3701H121.25V25.3701C121.2 28.0001 119.62 29.5901 117 29.5901Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.06 39.5101C120.394 39.5101 127.15 32.7541 127.15 24.4201C127.15 16.0861 120.394 9.33008 112.06 9.33008C103.726 9.33008 96.97 16.0861 96.97 24.4201C96.97 32.7541 103.726 39.5101 112.06 39.5101Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121 112.63H47.8601V58.2002H63.9001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121 57.2002V112.63",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.05 58.2002H103.45",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.78 89.9601V56.8401",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.54 82.9102H98.78",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8601 82.9102H64.3901",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.78 114.98V104.11",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.62 41.6902H137.5V129.13H25.5C22.3731 129.13 19.3742 127.888 17.1632 125.677C14.9521 123.466 13.71 120.467 13.71 117.34",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1799 41.6902H91.4299",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 40.0502C12.5126 37.8453 13.0987 35.6816 14.2005 33.7717C15.3024 31.8618 16.8822 30.2714 18.7846 29.1567C20.6871 28.0421 22.8468 27.4415 25.0516 27.4141C27.2564 27.3866 29.4304 27.9332 31.36 29.0002V107.47C29.4267 106.401 27.2481 105.855 25.0392 105.884C22.8302 105.914 20.6671 106.519 18.7632 107.64C16.8593 108.76 15.2804 110.357 14.1821 112.274C13.0837 114.191 12.504 116.361 12.5 118.57V40.0502Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetMapPinGrey);
export default __webpack_public_path__ + "static/media/sheet_map_pin_grey.6dd4b65b64053295f8b70f2b45c8e552.svg";
export { ForwardRef as ReactComponent };